<template>
  <footer class="vab-footer">
    <div class="flex_space logo_box flex_center_align">
      <img class="logo_img" src="~@/assets/images/logo.png" />
      <div class="flex_space">
        <div class="fot_word mg no_img flex_center_align" @click="goTom">
          <svg-icon
            icon-class="tryangle_right1"
            class="fot_word_svg"
          ></svg-icon>
          <span>TOMOONI利用約款</span>
        </div>
        <div class="fot_word no_img flex_center_align" @click="goWorks">
          <svg-icon
            icon-class="tryangle_right1"
            class="fot_word_svg"
          ></svg-icon>
          <span>Works特約</span>
        </div>
      </div>
    </div>
    <div class="flex_center flex_center_align bn_box">
      <span class="bn">
        Copyright DAIWA LIFENEXT CO., LTD. All rights reserved.
      </span>
    </div>
  </footer>
</template>

<script>
  import { tomooniUrl, worksUrl } from '@/config/setting.config'
  export default {
    name: 'VabMainFooter',
    data() {
      return {}
    },
    methods: {
      goTom() {
        if (tomooniUrl) {
          window.open(tomooniUrl, '_blank')
        }
      },
      goWorks() {
        if (worksUrl) {
          window.open(worksUrl, '_blank')
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .vab-footer {
    background: $base-color-white;
  }
  .bn_box {
    border-top: 1px solid #fa0046;
    .bn {
      font-weight: 400;
      font-size: 11px;
      color: #848484;
      padding: 6px 0;
    }
  }
  .logo_box {
    padding: 4px 32px;
    width: 100%;
    box-sizing: border-box;
  }
  .fot_word {
    font-weight: 400;
    font-size: 12px;
    color: #004c82;
    padding-left: 15px;
    cursor: pointer;
    &.mg {
      margin-right: 30px;
    }
  }
  .logo_img {
    height: 50px;
    width: auto;
  }
</style>
